import test from "./plugins/test.js"
import transferValuePlugin from "./plugins/transferValue.js"
export default {
  mixins: [test, transferValuePlugin]
}
